// 存储配置接口列表数据（如 /common/config），带副作用的接口不可放在这里
// 配置接口 store，如语言/城市列表
import _ from 'lodash'
import { getCommonConfig } from '@/api/common'
import { fetchFontList } from '@/api/common/font'
import { localLanguage } from '@/common/storage'

export default {
  namespaced: true,

  state: {
    gmaker: {},
    veditor: {},
    countries: [],
    fontList: [],
    languages: [],
    veditor_languages: [],
  },

  actions: {
    /**
     * getCommonConfig
     * @param state
     * @param useCache {boolean}
     * @param names {string[]} 配置项数组
     * @returns {Promise<*>}
     */
    async getCommonConfig({ state }, { useCache = true, names = [] }) {
      // http://playable.dev.com:8066/common/config?names=creative_provider,traffic_limits
      let filterNames = [...names]
      // 使用缓存
      if (useCache) {
        // 从缓存中可以获取到所有数据
        if (
          (names.filter((name) => _.isEmpty(state[name])) || []).length === 0
        ) {
          return _.cloneDeep(_.pick(state, names))
        }
        // 从缓存中无法获取到所有数据
        filterNames = names.filter((name) => _.isEmpty(state[name]))
      }

      const res = await getCommonConfig({ names: filterNames.join(',') })
      const data = _.get(res, 'data.data')

      const utils = {
        // 国家
        countries: (list) => {
          return list.map((item) => {
            const country = {
              ...item,
              value: item.code,
              label: item.name,
            }
            delete country.code
            delete country.name
            return country
          })
        },
        languages: (languages) => {
          return languages.map((x) => {
            const nameMaps = {
              'zh-cn': x.name,
              en: x.name_en || x.name, // 未翻译默认中文
              ja: x.name_jp || x.name_en || x.name, // 未翻译默认英文、中文
            }

            return {
              ...x,
              name: nameMaps[localLanguage.get()],
            }
          })
        },
      }

      _.each(filterNames, (key) => {
        const cooker = _.get(utils, `${key}.cooker`) || _.get(utils, `${key}`)

        // 需要特殊加工
        if (_.isFunction(cooker)) {
          state[key] = cooker(data[key])
        } else {
          // 默认直接赋值即可
          state[key] = data[key]
        }
      })
      return _.cloneDeep(_.pick(state, names))
    },

    async getGmakerConfig({ state, dispatch }, useCache = true) {
      const res = await dispatch('getCommonConfig', {
        useCache,
        names: ['gmaker'],
      })
      return _.get(res, 'gmaker')
    },

    async getCountryList({ state, dispatch }, useCache = true) {
      const res = await dispatch('getCommonConfig', {
        useCache,
        names: ['countries'],
      })
      return _.get(res, 'countries')
    },

    async getLanguagesList({ state, dispatch }, useCache = true) {
      const res = await dispatch('getCommonConfig', {
        useCache,
        names: ['languages'],
      })
      return _.get(res, 'languages')
    },

    async getFontList({ state }, useCache = true) {
      if (useCache && !_.isEmpty(state.fontList)) return state.fontList
      const res = await fetchFontList()
      const list = _.uniqWith(_.get(res, 'data.data.list') || [], _.isEqual)
      state.fontList = list
      return list
    },

    async getVeditorConfig({ state, dispatch }, useCache = true) {
      const res = await dispatch('getCommonConfig', {
        useCache,
        names: ['veditor'],
      })
      return _.get(res, 'veditor')
    },

    // 视频项目使用的语言数据
    async getVeditorLanguagesList({ state, dispatch }, useCache = true) {
      const res = await dispatch('getCommonConfig', {
        useCache,
        names: ['veditor_languages'],
      })

      return _.get(res, 'veditor_languages')
    },
  },
}
